(function () {
  'use strict';

  function initLoadMore(sectionEl) {
    var loadMoreBtn = sectionEl.querySelector('[data-load-more]');
    if (!loadMoreBtn) return;

    // The grid can be split by banner / mosaic / categorie — append to the last part
    var grids = sectionEl.querySelectorAll('[data-product-grid], [data-product-grid-after-banner]');
    var targetGrid = grids[grids.length - 1];
    var loadingText = sectionEl.querySelector('[data-loading-text]');

    loadMoreBtn.addEventListener('click', async function (e) {
      e.preventDefault();

      var nextUrl = this.dataset.nextUrl;
      if (!nextUrl) return;

      var btn = this;
      btn.style.display = 'none';
      if (loadingText) loadingText.style.display = 'block';

      try {
        var response = await fetch(nextUrl);
        if (!response.ok) throw new Error('HTTP ' + response.status);

        var html = await response.text();
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newProducts = doc.querySelectorAll('[data-product-item]');
        var newPagination = doc.querySelector('[data-load-more]');

        var existingWidgets = Array.from(document.querySelectorAll('.feedaty_widget'));

        newProducts.forEach(function (product) {
          targetGrid.appendChild(product.cloneNode(true));
        });

        if (newPagination) {
          btn.dataset.nextUrl = newPagination.dataset.nextUrl;
          btn.style.display = '';
          if (loadingText) loadingText.style.display = 'none';
        } else {
          if (loadingText) loadingText.style.display = 'none';
        }

        if (typeof window.Shopify !== 'undefined' && window.Shopify.PaymentButton) {
          window.Shopify.PaymentButton.init();
        }

        document.dispatchEvent(new CustomEvent('jkl:products-loaded', {
          detail: { count: newProducts.length }
        }));

        reinitFeedat(existingWidgets);

      } catch (error) {
        console.error('[load-more] fetch error:', error);
        btn.style.display = '';
        if (loadingText) loadingText.style.display = 'none';
      }
    });
  }

  function reinitFeedat(existingWidgets) {
    var fw;
    try { fw = FeedatyWidget; } catch (e) {}
    if (!fw || typeof fw.init !== 'function') return;

    existingWidgets.forEach(function (w) { w.classList.remove('feedaty_widget'); });

    delete fw.firstLoad;
    fw.init();

    setTimeout(function () {
      existingWidgets.forEach(function (w) { w.classList.add('feedaty_widget'); });
    }, 0);
  }

  var sections = document.querySelectorAll('.jkl-product-grid');
  sections.forEach(initLoadMore);

})();
